/** Stable Turnstile action id for CRM password login. Must match siteverify. */
export const TURNSTILE_LOGIN_ACTION = "login";
